const apiUrl = process.env.REACT_APP_API_URL;

const getComponentByModuleID = (token, assetID, moduleID, cb) => {
    fetch(`${apiUrl}/GetComponentByModuleID/${assetID}/${moduleID}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getComponentByModuleID;
